let data = {
    language: [
        {
            id: 1,
            name: "Assamese",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Assamese.png",
            link: "https://en.wikipedia.org/wiki/Assamese_language.org"
        },
        {
            id: 2,
            name: "Bengali",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Bengali.png",
            link: "https://en.wikipedia.org/wiki/Bengali_language.org"
        },
        {
            id: 3,
            name: "Bodo",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Bodo.png",
            link: "https://en.wikipedia.org/wiki/Bodo_language"
        },
        {
            id: 4,
            name: "Dogri",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Dogri.png",
            link: "https://en.wikipedia.org/wiki/Dogri"
        },
        {
            id: 5,
            name: "Gujarati",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Gujarati.png",
            link: "https://en.wikipedia.org/wiki/Gujarati_language"
        },
        {
            id: 6,
            name: "Hindi",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Hindi.png",
            link: "https://en.wikipedia.org/wiki/Hindi"
        },
        {
            id: 7,
            name: "Kannada",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Kannada.png",
            link: "https://en.wikipedia.org/wiki/Kannada"
        },
        {
            id: 8,
            name: "Kashmiri",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Kashmiri.png",
            link: "https://en.wikipedia.org/wiki/Kashmiri_language"
        },
        {
            id: 9,
            name: "Konkani",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Konkani.png",
            link: "https://en.wikipedia.org/wiki/Konkani"
        },
        {
            id: 10,
            name: "Maithili",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Maithili.png",
            link: "https://en.wikipedia.org/wiki/Maithili_language"
        },
        {
            id: 11,
            name: "Malayalam",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Malayalam.png",
            link: "https://en.wikipedia.org/wiki/Malayalam"
        },
        {
            id: 12,
            name: "Meitei",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Meitei.png",
            link: "https://en.wikipedia.org/wiki/Meitei_language"
        },
        {
            id: 13,
            name: "Marathi",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Marathi.png",
            link: "https://en.wikipedia.org/wiki/Marathi_language"
        },
        {
            id: 14,
            name: "Nepali",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Nepali.png",
            link: "https://en.wikipedia.org/wiki/Nepali_language"
        },
        {
            id: 15,
            name: "Odia",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Odia.png",
            link: "https://en.wikipedia.org/wiki/Odia_language"
        },
        {
            id: 16,
            name: "Punjabi",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Punjabi.png",
            link: "https://en.wikipedia.org/wiki/Punjabi_language"
        },
        {
            id: 17,
            name: "Sanskrit",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Sanskrit.png",
            link: "https://en.wikipedia.org/wiki/Sanskrit"
        },
        {
            id: 18,
            name: "Santali",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Santhali.png",
            link: "https://en.wikipedia.org/wiki/Santali_language"
        },
        {
            id: 19,
            name: "Sindhi",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Sindhi.png",
            link: "https://en.wikipedia.org/wiki/Sindhi_language"
        },
        {
            id: 20,
            name: "Tamil",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Tamil.png",
            link: "https://en.wikipedia.org/wiki/Tamil_language"
        },
        {
            id: 21,
            name: "Telugu",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Telugu.png",
            link: "https://en.wikipedia.org/wiki/Telugu_language"
        },
        {
            id: 22,
            name: "Urdu",
            img: "https://raw.githubusercontent.com/ssahibsingh/rlc-img-hosting/main/Urdu.png",
            link: "https://en.wikipedia.org/wiki/Urdu"
        },
    ]
}

export default data;